import React from "react";
import cx from "classnames";
import { isNoEditRoute } from "../../hooks/helpers";
import { Button, Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { webView, webviewEvents } from "../../variables/webView";
import StarImg from "./img/star-primary.svg";
import usePremium from "../../hooks/usePremium";

export default function StepCustomize({ emulate, disabled, className }) {
  const { lang, langMob, errorFile, langSave, locale, langTryProButton } = useSelector(
    (state) => ({
      lang: state.changeLang.language.stepButton,
      langMob: state.changeLang.language.stepButtonMob,
      errorFile: state.getQrLinkSlice.errorFile,
      langSave: state.changeLang.language.modalDownloadQr[18],
      locale: state.changeLang.change,
      langTryProButton: state.changeLang.language.tryProButton,
    })
  );
  const { isPremium } = usePremium();
  const { isPremiumLite } = usePremium();

  const handleButton = () => {
    if (!errorFile) {
      const type = window.location.pathname.split("/").filter(Boolean).pop();
      gtag("event", "customize_download_qr", {
        site_language: locale.toUpperCase?.(),
        type: (type === "link" ? "url/link" : type)
      });
        window?.fbq && fbq("track", "CustomizeDownloadQr");
      if (webView && webviewEvents) {
        window.ReactNativeWebView.postMessage("app_customize_qr");
      }
      emulate();
    }
  };

  const ButtonCustomize = () => (
    <Button
      id="secondStepClick"
      variant="primary"
      className={cx("text-white w-100 fs-bold py-3", {
        "bg-border-gray border-border-gray": disabled,
      })}
      disabled={disabled}
      onClick={handleButton}
    >
      {isNoEditRoute ? (
        <>
          <span className="d-none d-lg-inline">{lang}</span>
          <span className="d-lg-none">{langMob}</span>
        </>
      ) : (
        langSave
      )}
    </Button>
  );

  const handleTryProBtn = () => {
    const type = window.location.pathname.split("/").filter(Boolean).pop();
    gtag("event", "button_try_pro_version", {
      site_language: locale.toUpperCase?.(),
      type: (type === "link" ? "url/link" : type)
  });
    window.location.href = `${window.location.origin}${
      locale === "en" ? "" : `/${locale}`
    }/pricing#pricing-table`;
  };



  if (!isPremium && !isPremiumLite && !webView) {
    return (
      <Col
        className={cx(
          "mx-auto mt-4 mb-0 mb-md-4",
          className || "col-12 col-lg-6 pe-md-5"
        )}
      >
        <Row className="g-4">
          <Col>
            <ButtonCustomize />
          </Col>
          <Col>
            <div>
              <Button
                onClick={handleTryProBtn}
                variant="outline-primary"
                className="w-100 py-3 try-pro-btn"
              >
                <img
                  src={StarImg}
                  alt="try pro"
                  width="16"
                  height="16"
                  className="me-2 mb-1 text-primary"
                />
                <span className="d-none d-lg-inline">{langTryProButton[0]}</span>
                <span className="d-lg-none">{langTryProButton[2]}</span>
              </Button>
              <div className="text-primary fs-9 mt-1 text-center">
                {langTryProButton[1]}
              </div>
            </div>
          </Col>
        </Row>
      </Col>
    );
  }

  return (
    <Col
      xs={12}
      lg={4}
      md={6}
      className={cx("mx-auto mt-4 mb-0 mb-md-4", {
        [className]: !!className,
      })}
    >
      <ButtonCustomize />
    </Col>
  );
}
